<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="请选择机构" prop="organizationId" >
        <a-select v-model="form.organizationId" placeholder="请选择机构" allow-clear>
          <a-select-option v-for="item in organizationList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.user" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="平均分" prop="average" >
        <a-input v-model="form.average" placeholder="请输入平均分" />
      </a-form-model-item>
      <a-form-model-item label="效果分" prop="effect" >
        <a-input v-model="form.effect" placeholder="请输入效果分" />
      </a-form-model-item>
      <a-form-model-item label="师资分" prop="teachers" >
        <a-input v-model="form.teachers" placeholder="请输入师资分" />
      </a-form-model-item>
      <a-form-model-item label="环境分" prop="environment" >
        <a-input v-model="form.environment" placeholder="请输入环境分" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="picture" >
        <a-input v-model="form.picture" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="评论内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGrade, addGrade, updateGrade } from '@/api/grade/grade'
import Editor from '@/components/Editor'
import {listOrganization} from "@/api/organization/organization";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      organizationList: [],
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        organizationId: null,

        userId: null,

        average: null,

        effect: null,

        teachers: null,

        environment: null,

        picture: null,

        content: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        organizationId: [
          { required: true, message: '机构id,外键{zb_organization.id}不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        average: [
          { required: true, message: '平均分不能为空', trigger: 'blur' }
        ],
        effect: [
          { required: true, message: '效果分不能为空', trigger: 'blur' }
        ],
        teachers: [
          { required: true, message: '师资分不能为空', trigger: 'blur' }
        ],
        environment: [
          { required: true, message: '环境分不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '图片不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        organizationId: null,
        userId: null,
        average: null,
        effect: null,
        teachers: null,
        environment: null,
        picture: null,
        content: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    getOrganizationList () {
      listOrganization().then(response => {
        this.organizationList = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.getOrganizationList()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getOrganizationList()
      this.formType = 2
      const id = row ? row.id : ids
      getGrade({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGrade(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGrade(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
